import script from "./SearchResultMaterial.vue?vue&type=script&lang=ts&setup=true"
export * from "./SearchResultMaterial.vue?vue&type=script&lang=ts&setup=true"

import "./SearchResultMaterial.vue?vue&type=style&index=0&id=1226cd29&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1226cd29"]])

export default __exports__